/** @module DataLayerHotelDetailsClick */

import {
  DataLayerEventHotelDetail,
  DataLayerHotelDetail,
} from "@/../types/data-layer";
import { DATA_LAYER_HOTEL_DETAILS_CLICK } from "@/constants";

/**
 * @Class
 * Representation of a product item listing from a user view for use in Google Tag Manager.
 * This data layer event is part of UA Enhanced Ecommerce tracking framework.
 *
 * https://aircanadavacations.atlassian.net/wiki/spaces/AW/pages/2430304265/Use+of+Product+Tile+Elements+-+Promo+Pages
 */
export class DataLayerHotelDetailsClick {
  /**
   *
   * @param {DataLayerHotelDetail} details
   */
  static create(details: DataLayerHotelDetail): DataLayerEventHotelDetail {
    return {
      event: DATA_LAYER_HOTEL_DETAILS_CLICK,
      tileElementName: details.element_name,
      tileElementValue: details.hotel_name,
    };
  }
}
